import { BDrugItem } from '@pharmsnap/shared/components'
import { useRequest } from '@pharmsnap/shared/composition/useRequest'
import { sharedCtx } from '@pharmsnap/shared/context'
import { defineComponent, PropType } from '@vue/composition-api'
import { BBasicLoadingCard } from '../BBasicLoadingCard/BBasicLoadingCard'
export const BDrugFetchListCard = defineComponent({
  name: 'BDrugFetchListCard',
  props: {
    ids: {
      type: Array as PropType<string[]>,
      required: true,
    },
    coreIds: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  setup(props) {
    const { loading, data } = useRequest(
      {
        requestFn: sharedCtx.service.drug.getBatchDrugs.bind(sharedCtx.service.drug),
      },
      props.ids
    )
    return {
      loading,
      data,
    }
  },
  render() {
    return (
      <BBasicLoadingCard loading={this.loading}>
        <div class="flex flex-wrap">
          {this.data?.map((item) => {
            return <BDrugItem class="mr-1 mb-1" data={item} coreIds={this.coreIds} showCard></BDrugItem>
          })}
        </div>
      </BBasicLoadingCard>
    )
  },
})
